import { v4 as uuidv4 } from 'uuid';
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

export type ChatManager = {
  id: string;
  authorName: string;
  authorAvatarUrl: string;
  actionBlock?: boolean;
}

const defaultManagers: ChatManager[] = [
  {
    id: '2cce750b-d58b-44c2-ad27-fc1ab1fea458',
    authorName: 'Анна',
    authorAvatarUrl: 'https://randomuser.me/api/portraits/women/43.jpg'
  },
  {
    id: '1cdfbf1b-1b1e-4084-a102-f220c9ad5b3c',
    authorName: 'Анастасия',
    authorAvatarUrl: 'https://randomuser.me/api/portraits/women/76.jpg'
  },
  {
    id: '6dab6cc8-8173-4620-9a55-ca89c2410857',
    authorName: 'Ирина',
    authorAvatarUrl: 'https://randomuser.me/api/portraits/women/48.jpg'
  },
  {
    id: '99b60f54-2c79-4f4b-9051-92c9044d64db',
    authorName: 'Елена',
    authorAvatarUrl: 'https://randomuser.me/api/portraits/women/49.jpg'
  }
];

type ManagersState = {
  items: ChatManager[];
};

const initialState: ManagersState = {
  items: defaultManagers
};

type AddPayload = { authorName: string; authorAvatarUrl: string };
type RemovePayload = { id: string };

export const managersSlice = createSlice({
  name: 'chatManagers',
  initialState,
  reducers: {
    addManager: (state: Draft<ManagersState>, { payload }: PayloadAction<AddPayload>) => {
      const managerId = uuidv4();

      if (state.items.length === 1 && state.items[0].actionBlock === true) {
        const newObj = {...state.items[0], actionBlock: false}
        state.items = [newObj]
      }

      state.items.push({
        id: managerId,
        authorName: payload.authorName,
        authorAvatarUrl: payload.authorAvatarUrl
      })
    },
    removeManager: (state: Draft<ManagersState>, { payload }: PayloadAction<RemovePayload>) => {
      state.items = state.items.filter(m => m.id !== payload.id);

      if (state.items.length === 1) {
        const newObj = {...state.items[0], actionBlock: true}
        state.items = [newObj]
      }
    },

    // tmp
    resetToDefault: (state) => {
      state.items = defaultManagers;
    }
  }
});

export const { addManager, removeManager } = managersSlice.actions;

export default managersSlice.reducer;
